import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import Store from '@/store'
import {
  Auth
} from 'aws-amplify'

const TourContainer = () => import( /**/ './components/Tour/TourContainer.vue')
const SuspectsComponent = () => import( /*webpackChunkName: "suspects"*/ './components/Suspects.vue')
const HelpComponent = () => import( /*webpackChunkName: "help"*/ './components/Help.vue')
const DemoComponent = () => import( /*webpackChunkName: "demo"*/ './components/ApplicationDemo.vue')

import {
  AuthRouter
} from './amplify'
Vue.use(Router)

const router = new Router({
  routes: [
    AuthRouter,
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'app',
      component: App,
      beforeEnter: (to, from, next) => {

        if (to.path === '/' && from.path == '/') {
          next('/tour')
        }
        if (to.path === '/suspects' && from.path == '/') {
          next('/')
        }
      
        if (to.path === '/help' && from.path === '/') {
          next('/')
        }
        next()
      },
      children: [{
          name: 'tour',
          path: '/tour',
          component: TourContainer,
        },
        {
          name: 'suspects',
          path: '/suspects',
          component: SuspectsComponent,
        },
        {
          path: '/help',
          component: HelpComponent
        }
      ]
    },
    {
      path: '/app-demo',
      component: DemoComponent
    }
  ]
})
const AuthFilter = (to, from, next) => {
  let localUser = Store.getters.localUser
  if (!localUser) {
    Auth.currentAuthenticatedUser()
      .then(async (user) => {
        if (Object.keys(user.attributes).length > 0) {
          Store.dispatch('setUser', user)
          await Store.dispatch('setLocalUser', user)
          next()
        }
        next()
      })
      .catch(err => {
        Store.dispatch('setUser', null)
        if (!to.name.startsWith('auth')) {
          next('/auth/signIn')
        } else {
          next()
        }
      })
  } else {
    next()
  }
}
router.beforeEach(AuthFilter);

export default router